// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#GraphMonitorDevice .content-boll{width:100%}#GraphMonitorDevice .content-boll:hover{-webkit-transform:scale(1.1);transform:scale(1.1)}#GraphMonitorDevice .content-boll .boll{height:60px;width:60px}#GraphMonitorDevice .content-boll .boll .body-boll span{font-size:29px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
